import {init as initPrism} from '../prism/main.js';
import {createConfig} from './config.js';
import {escapeHtml} from './utils.js';

let markedInstance = null;

const initMarked = async (headingOffset = 1) => {
    if (markedInstance) {
        return markedInstance;
    }

    try {
        const {marked} = await import('marked');
        const {sanitize} = await import('dompurify');
        await import('./styles.css');

        const config = createConfig(headingOffset);
        marked.use(config);
        markedInstance = {marked, sanitize};

        return markedInstance;
    } catch (error) {
        console.warn('Marked and DOMPurify libraries not available:', error);
        return null;
    }
};

const renderMarkdown = async (text, instance = markedInstance) => {
    if (instance?.marked && instance?.sanitize) {
        const html = instance.marked.parse(text);
        const safeHtml = instance.sanitize(html);

        // Create temporary element to find and highlight code blocks
        const tempEl = document.createElement('div');
        tempEl.innerHTML = safeHtml;

        // Initialise Prism on any code blocks with language class
        const codeBlocks = tempEl.querySelectorAll('code[class*="language-"]');
        if (codeBlocks.length) {
            await Promise.all([...codeBlocks].map(initPrism));
        }

        return tempEl.innerHTML;
    }

    // Fallback to simple HTML escaping
    return escapeHtml(text);
};

export {initMarked, renderMarkdown};
